export default {
    'app.pwa.offline': 'You are offline now',
    'app.pwa.serviceworker.updated': 'New content is available',
    'app.pwa.serviceworker.updated.hint': 'Please press the "Refresh" button to reload current page',
    'app.pwa.serviceworker.updated.ok': 'Refresh',
};
